import React from 'react';

import { Pill } from '../../../../../components/Pill';
import { type AccessPackagePillsProps } from '../types';
import {
  getAccessPackageVariant,
  capitalizeFirstLetter,
} from '../utils/supplierUtils';

export const AccessPackagePills: React.FC<AccessPackagePillsProps> = ({
  accessPackage,
  isIntegrated,
}) => {
  return (
    <div className="flex flex-col gap-1">
      <Pill variant={getAccessPackageVariant(accessPackage)}>
        {capitalizeFirstLetter(accessPackage || 'free')}
      </Pill>
      {isIntegrated && <Pill variant="success">Integrated</Pill>}
    </div>
  );
};
